import {DataTableSortStatus} from 'mantine-datatable';
import {DefectSignature} from '../types';

// ⚠️ THE COMPARATOR NO LONGER LIVES HERE (FNP-923).
//
// This file used to carry a full comparator — nulls-last, numeric-vs-string,
// empty-string-as-missing. It was written for FNP-904 the night before FNP-912
// published exactly that logic to `@flexinet/ui-components`, which is the
// duplication FNP-912 exists to prevent. Use the shared one:
//
//     import {useTableSort} from '@flexinet/ui-components';
//
// What remains is the one genuinely per-entity decision: WHICH key this table
// sorts by. How to compare two values is universal; what "most important first"
// means for a defect is not.

// DEFAULT: most-recently-seen first.
//
// WHY lastSeenAt AND NOT occurrenceCount — the question an operator opens this
// page to ask is "what is breaking NOW", not "what has broken most over all
// time". A defect last seen an hour ago outranks one that stopped six weeks
// back whatever its lifetime count.
//
// The key is non-null (`lastSeenAt: AWSDateTime!` — the sweep sets it on every
// occurrence) and effectively immutable per occurrence, so the default ordering
// is always meaningful rather than degrading to page-arrival order.
//
// ⚠️ It is NOT `updated`: that moves whenever a human triages a defect, so the
// list would reorder itself under someone who is reading it.
export const DEFAULT_SORT: DataTableSortStatus<DefectSignature> = {
    columnAccessor: 'lastSeenAt',
    direction: 'desc',
};
